import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import type { SendAnalyticsEvent } from '@atlassian/conversation-assistant-instrumentation/types/analytics';
import type { Message } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { getScheduleRovoChatRuleIdUuidFromExecutionMessage } from './getScheduleRovoChatRuleIdUuidFromExecutionMessage';

export const trackScheduledChatCreated = ({
	message,
	conversationId,
	sourceMessageId,
	humanMessageId,
	sendAnalyticsEvent,
}: {
	message: Message;
	conversationId: string;
	sourceMessageId: string;
	humanMessageId?: string;
	sendAnalyticsEvent: SendAnalyticsEvent;
}): void => {
	// The backend supplies this ID after persisting the schedule. A click or
	// a successful confirmation transport alone does not establish creation.
	const ruleIdUuid = getScheduleRovoChatRuleIdUuidFromExecutionMessage(message);
	if (!ruleIdUuid || !isExperimentEnabled('rovo_chat_schedule_chat_skill_experiment')) {
		return;
	}

	sendAnalyticsEvent({
		eventType: 'track',
		action: 'created',
		actionSubject: 'scheduledChat',
		attributes: {
			conversationId,
			conversationChannelId: message.conversation_channel_id ?? conversationId,
			messageId: message.id,
			sourceMessageId,
			humanMessageId,
			// Count distinct rule IDs downstream to deduplicate replayed responses.
			ruleIdUuid,
		},
	});
};
